import { render, staticRenderFns } from "./CustomersChartBlock.vue?vue&type=template&id=f632a56c&scoped=true"
import script from "./CustomersChartBlock.vue?vue&type=script&lang=js"
export * from "./CustomersChartBlock.vue?vue&type=script&lang=js"
import style0 from "./CustomersChartBlock.vue?vue&type=style&index=0&id=f632a56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f632a56c",
  null
  
)

export default component.exports